import React, { FC, useCallback, useState } from "react";
import { ButtonProps, Dialog, Input } from "@xapp/components";

import { BasicIntegrationCard, IntegrationCardProp } from "./BasicIntegrationCard";

export interface SurefireLocalConnectionProps {
    integration: "surefire";
    token: string;
}

export interface SurefireLocalIntegrationCardProps extends IntegrationCardProp {
    token?: string;

    onConnect?(props: SurefireLocalConnectionProps): void;
}

export const SurefireLocalIntegrationCard: FC<SurefireLocalIntegrationCardProps> = (props) => {

    const { disabled, isLinked, isActive, onConnect, onDisconnect } = props;

    const [token, setToken] = useState<string>(props.token || "");
    const [showDialog, setShowDialog] = useState<boolean>(false);

    const handleSurefireLocalClick = (e: React.MouseEvent<HTMLAnchorElement>): void => {
        e.preventDefault();
        // pop up modal
        setShowDialog(true);
    };

    const handleConnectSurefireLocal = useCallback(() => {
        if (typeof onConnect === "function") {
            onConnect({ integration: "surefire", token });
            setShowDialog(false);
        }
    }, [onConnect, token]);

    const handleDisconnectSurefireLocal = useCallback(() => {
        if (typeof onDisconnect === "function") {
            onDisconnect();
        }
    }, [onDisconnect]);

    const actions: ButtonProps[] = [
        {
            label: "Close",
            variation: "secondary",
            onClick: () => { setShowDialog(false) }
        }
    ];

    if (typeof onConnect === "function") {
        actions.push({
            label: "Connect",
            variation: "primary",
            disabled: !token,
            onClick: handleConnectSurefireLocal
        });
    }

    return (
        <>
            <BasicIntegrationCard
                disabled={disabled}
                imageUrl="/img/integrations/surefire-local/surefire-local-logo.png"
                text="Surefire Local"
                href={() => "/integrations/surefire-local"}
                onClick={handleSurefireLocalClick}
                isLinked={isLinked}
                isActive={isActive}
                onDisconnect={typeof onDisconnect === "function" ? handleDisconnectSurefireLocal : undefined}
            />
            <Dialog
                active={showDialog}
                actions={actions}
                title="Surefire Local Setup"
                onClose={() => { setShowDialog(false) }}
            >
                <p>You will need to contact your Surefire Local representative to get your API token.</p>
                {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                {/* @ts-ignore */}
                <Input label="API Token" value={token} onChange={setToken} />
            </Dialog>
        </>
    );
}